import { Injectable } from "@angular/core";
import { Observable, shareReplay } from "rxjs";
import { map } from "rxjs/operators";
import { ILobbyConfig } from "./interfaces";
import { HttpService } from "@karma-games/angular-devkit/src/lib/services/http";
import { IRepository } from "@karma-games/angular-devkit/src/lib/interfaces";


@Injectable()
export class LobbyConfigRepository implements IRepository<ILobbyConfig | undefined> {
    private config$: Observable<ILobbyConfig | undefined> | undefined = undefined;

    constructor(
        private http: HttpService
    ) {
    }

    get(): Observable<ILobbyConfig | undefined> {
        if (!this.config$) {
            this.config$ = this.requestConfig().pipe(
                shareReplay(1)
            );
        }

        return this.config$;
    }

    private requestConfig(): Observable<ILobbyConfig|undefined> {
        return this.http.get("configuration")
            .pipe(map(response => <ILobbyConfig>{
                balanceAvailable: typeof response.body.data.balanceAvailable === "boolean" ? response.body.data.balanceAvailable : true,
                ...response.body.data
            }));
    }
}
